module.exports = __webpack_public_path__ + "img/peroneo_dx.ae31ff85.png";